module.exports = __webpack_public_path__ + "static/media/05-07.b6dfb6ce.png";